import { type JSX } from 'react';

import { EloProgressCircle } from '@plurall/elo-v3';

import { NavLoadingItemFactory } from './factories/local-navigation-section-factory';

type LocalNavigationLoadingItemProps = {
  isLoadingMenu: boolean;
};

export function LocalNavigationLoadingItem({ isLoadingMenu }: LocalNavigationLoadingItemProps): JSX.Element | null {
  if (!isLoadingMenu) return null;

  return (
    <NavLoadingItemFactory>
      <EloProgressCircle
        data-test-id='progress'
        size='x-small'
      />
    </NavLoadingItemFactory>
  );
}
